// SidebarHeader Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import IconButton from '../../common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'

class SidebarHeader extends Component {
  static get propTypes () {
    return {
      title: PropTypes.string,
      onChangeTab: PropTypes.func,
      onClose: PropTypes.func,
      tabs: PropTypes.array,
      activeTab: PropTypes.string,
      icon: PropTypes.string,
      isViewMode: PropTypes.bool,
      showCloseBorder: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      title: '',
      onChangeTab: null,
      onClose: null,
      tabs: [],
      activeTab: '',
      icon: '',
      isViewMode: false,
      showCloseBorder: false
    }
  }

  render () {
    const {
      title,
      icon,
      tabs,
      activeTab,
      onChangeTab,
      onClose,
      isViewMode,
      showCloseBorder
    } = this.props

    return (
      <div className='csidebar-header'>
        <div className='csidebar-header-content'>
          <div className='maininfo'>
            <div className='titleinfo'>
              <div className='icon-content'>
                {isViewMode ? (
                  <IconButton
                    icon='eye'
                    size='big'
                    type='invert'
                    className='sheaderaction'
                  />
                ) : (
                  <IconButton
                    icon={icon}
                    size='big'
                    type='invert'
                    className='sheaderaction'
                  />
                )}
              </div>
              <div className='title'>
                <IntlMessage ident={title} />
              </div>
              {showCloseBorder ? (
                <div className='outercont'>
                  <IconButton
                    icon='x'
                    size='big'
                    type='secondary'
                    iconSize='16'
                    className='actionclose'
                    onClick={onClose}
                  />
                </div>
              ) : (
                <IconButton
                  icon='x'
                  size='big'
                  type='secondary'
                  iconSize='16'
                  className='actionclose'
                  onClick={onClose}
                />
              )}
            </div>
          </div>

          {tabs && tabs.length > 0 && (
            <div className='sidebar-tabs'>
              <div className='tabction' />
              <div className='items'>
                {tabs.map(tab => (
                  <div
                    className={`tabitem${
                      tab.ident === activeTab ? ' active' : ''
                    }`}
                    key={tab.ident}
                    onClick={ev => onChangeTab && onChangeTab(tab, ev)}
                  >
                    <IntlMessage ident={tab.title} />
                  </div>
                ))}
              </div>
              <div className='tabction' />
            </div>
          )}
        </div>
      </div>
    )
  }
}

export default SidebarHeader
